import { render, staticRenderFns } from "./money-detail.vue?vue&type=template&id=75e2de97&scoped=true&"
import script from "./money-detail.vue?vue&type=script&lang=js&"
export * from "./money-detail.vue?vue&type=script&lang=js&"
import style0 from "./money-detail.vue?vue&type=style&index=0&id=75e2de97&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75e2de97",
  null
  
)

export default component.exports